import { Link as MuiLink } from '@mui/material';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import linkDefaultStyle from './linkDefaultStyle';
import { Box } from '../../Box';
import inlineLinkDefaultStyle from './inlineLinkDefaultStyle';

/** A standard anchor element  */
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Link = props => {
  const {
    size,
    href,
    children,
    sx,
    id,
    linkIcon,
    visitedStyle = true,
    target,
    rel,
    inline = false,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const style = inline ? mergeSxStyle(inlineLinkDefaultStyle(theme, size, visitedStyle), sx) : mergeSxStyle(linkDefaultStyle(theme, size || 'md', visitedStyle), sx);
  const renderIcon = (condition, icon) => {
    if (condition) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: icon
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsx(MuiLink, {
    id: id,
    "data-testid": rest['data-testid'],
    href: href,
    underline: inline ? 'always' : 'none',
    target: target,
    rel: rel || target === '_blank' ? 'noopener noreferrer' : rel,
    component: 'a',
    sx: style,
    children: /*#__PURE__*/_jsxs(Box, {
      display: 'flex',
      gap: '8px',
      flexDirection: 'row',
      alignItems: 'center',
      component: 'span',
      children: [renderIcon(linkIcon?.start, linkIcon?.icon), children, renderIcon(linkIcon?.end, linkIcon?.icon)]
    })
  });
};